<template>
  <div class="manager_box">
    <div>
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in tableData1" :key="index" :label="item.realname" :name="item.staff_id" ></el-tab-pane>
      </el-tabs>-->
    </div>
    <div>
      <div class="filter_box">
        <div class="search_button" style="margin-right: 20px">
          <el-cascader
            v-model="region_value"
            :options="region_options"
            @change="handleChange"
            style="margin-right: 20px; min-width: 150px"
          ></el-cascader>
          <el-input
            placeholder="请输入内容"
            @input="input_search"
            v-model="search_name"
            class="input-with-select"
            style="margin-right: 20px; width: 300px"
          >
            <el-select
              v-model="search_value"
              slot="prepend"
              placeholder="请选择"
              style="width: 100px"
              @change="option_input"
            >
              <el-option label="不限" value>不限</el-option>
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-button slot="append" @click="button_search" icon="el-icon-search"></el-button> -->
          </el-input>
          <el-button @click="button_search" icon="el-icon-search" type="primary"
            >搜索</el-button
          >
        </div>
        <div class="other_div">
          <div style="white: 300px">
            <el-date-picker
              v-model="valueDate"
              type="daterange"
              @change="changedate"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>

          <div
            class="block"
            v-if="$cookies.get('auth_grade') == 100"
            style="min-width: 150px"
          >
            <el-select
              v-model="department_value"
              placeholder="请选择"
              @change="department_change"
            >
              <el-option
                v-for="item in department_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="tab_name">
        <div v-for="(item, index) in tab_name_list" :key="item.name">
          <el-tag
            v-if="item.value != ''"
            style="margin: 10px 20px"
            @close="close_tab(index)"
            closable
            type
            >{{ item.name }}：{{ item.value }}</el-tag
          >
        </div>
      </div>
    </div>

    <div class="main" style="width: 100%" v-loading="loading">
      <div class="btn_box">
        <el-button type="primary" @click="toggle">添加到基础工作</el-button>
        <el-button
          type="danger"
          v-if="$cookies.get('auth_grade') == 100"
          @click="deleted_button"
          >删除客户</el-button
        >
      </div>
      <el-table
        :data="tableData"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="客户名称">
          <template slot-scope="scope">
            <el-button type="text" @click="showTable(scope.row)">
              {{ scope.row.client_name }}
            </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column label="性别">
          <template slot-scope="scope">{{ scope.row.client_gender==1?'男':'女'}}</template>
        </el-table-column>-->
        <el-table-column label="公司名称" prop="company_name"></el-table-column>
        <el-table-column
          label="客户类别"
          sortable="custom"
          prop="client_sort"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          label="公司职位"
          prop="company_position"
        ></el-table-column>
        <!-- <el-table-column label="沟通备注" prop="com_remarks"></el-table-column> -->
        <!-- <el-table-column label="下次跟进时间" prop="next_follow_time"></el-table-column> -->
        <el-table-column label="公司地址" prop="area"></el-table-column>
        <el-table-column label="客户所属" prop="product_name"></el-table-column>
        <el-table-column
          label="跟进次数"
          sortable="custom"
          prop="follow_count"
          min-width="140px"
        ></el-table-column>
        <el-table-column
          label="上次跟进人"
          prop="recently_staff_name"
        ></el-table-column>
        <el-table-column label="流程状态">
          <template slot-scope="scope">
            <el-tag>
              {{
                scope.row.follow_status_name
                  ? scope.row.follow_status_name
                  : "新客户"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="微信号" prop="client_wx"></el-table-column>
        <el-table-column
          label="客户来源"
          prop="client_source"
        ></el-table-column>
        <el-table-column label="创建时间" prop="create_time"></el-table-column>
      </el-table>
      <div class="pagination">
        <div>选中：{{ multipleSelection.length }}</div>
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          @current-change="current_change"
          @size-change="pageSizeChange"
          :current-page.sync="cilent_Page"
          :page-size="pagesize"
          :total="sale_count"
        ></el-pagination>
        <div>
          当前页：{{ tableData.length }}&nbsp;/&nbsp;总数：{{ sale_count }}
        </div>
      </div>

      <el-drawer
        title="我是标题"
        size="800"
        :visible.sync="dialog"
        :with-header="false"
      >
        <div class="detail_info">
          <div>
            <!-- title -->
            <div class="nav_title">
              <div>{{ client_name }}</div>
            </div>

            <div class="rl_flex">
              <!-- 概况 -->
              <div class="nav_left">
                <!-- 跟进状态 -->
                <div>
                  <div class="status_box">
                    <!-- 字和点的位置 -->
                    <div class="status_iter">
                      <div
                        class="status_item"
                        v-for="(item, index) in status"
                        :key="index"
                      >
                        <div
                          class="title"
                          :class="index <= status_id ? 'status_color' : ''"
                        >
                          {{ item.follow_status_name }}
                        </div>
                      </div>
                    </div>
                    <div class="line_iter">
                      <div
                        class="cir_item"
                        v-for="(item, index) in status"
                        :key="index"
                      >
                        <div
                          :class="
                            index <= status_id ? 'iconduigoutianchong-' : ''
                          "
                          class="cir iconfont"
                        ></div>
                        <div
                          class="line_item"
                          :class="index < status_id ? 'status_back' : ''"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 客户概况 -->
                <div class="half_fl">
                  <div v-for="(item, index) in survey" :key="index">
                    <div class="title">{{ item.title }}</div>
                    <div v-if="item.value" class="cont">{{ item.value }}</div>
                  </div>
                </div>

                <!-- 客户总体概览 -->
                <div>
                  <div>
                    <div class="over_title">基本信息</div>
                    <div class="half_fl">
                      <div v-for="(item, index) in basic_info" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="cont">
                          {{ item.value == null || "" ? "暂无" : item.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="over_title">详细信息</div>
                    <div class="half_fl">
                      <div v-for="(item, index) in detail_info" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="cont">
                          {{ item.value == null ? "暂无" : item.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nav_right">
                <!-- <div class="record">跟进记录</div> -->
                <div class="rec_box" v-if="record.length > 0">
                  <div
                    class="item"
                    v-for="(item, index) in record"
                    :key="index"
                  >
                    <div class="item_flex">
                      <div class="com_name">
                        <i class="iconfont iconkehuguanli"></i>
                        {{ item.staff_name }}
                      </div>
                      <div class="item_grow">{{ item.create_time }}</div>
                    </div>
                    <div class="follow_detail">{{ item.follow_detail }}</div>
                    <!-- <div @click="del(item.follow_id,index)" class="follow_del">删除</div> -->
                  </div>
                </div>
                <div class="rec_box" v-else>
                  <div class="zanwu">暂无跟进记录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      department_value: "",
      department_list: [],

      jurisdiction: false,
      delete_button_torf: false,

      paging_up_and_down: "",
      prop_name: "",

      tableData1: [],
      activeName: "",
      Pie_chart_value: "",

      currentPage: 0,
      status_id_dict: {},
      cilent_Page: 0,
      sale_count: 0,
      pagesize: 15,
      options: [], //筛选列表
      tab_name_list: [
        { name: "客户名称", value: "" },
        { name: "公司名称", value: "" },
        { name: "客户来源", value: "" },
        { name: "手机号", value: "" },
        { name: "职位", value: "" },
        { name: "客户类别", value: "" },
        { name: "备注", value: "" },
        { name: "微信号", value: "" },
        { name: "地区详情", value: "" },
        // {name: "客户所属", value: ""},
        { name: "跟进人", value: "" },
        { name: "地区", value: "" },
      ], // 筛选条件
      search_value: "", //筛选选项
      place_data: [],
      client_name: "",
      loading: true,
      select_list: [],

      sale_class: [
        {
          label: "A",
          value: "0",
        },
        {
          label: "B",
          value: "1",
        },
        {
          label: "C",
          value: "2",
        },
        {
          label: "D",
          value: "3",
        },
      ],
      survey: [
        {
          title: "所属人员",
          value: "北京三门课科技有限公司",
        },
        {
          title: "客户类型",
          type: "",
          value: null,
        },
        {
          title: "下次跟进时间",
          type: "next_follow_time",
          value: null,
        },
      ],
      status: [],
      status_id: 0,
      sex: [
        {
          title: "男",
          value: 1,
        },

        {
          title: "女",
          value: 2,
        },
      ],
      basic_info: [
        {
          type: "client_name",
          title: "客户名称",
          value: null,
        },
        {
          type: "client_wx",
          title: "微信号",
          value: null,
        },
        // {
        //   type: "client_phone",
        //   title: "电话",
        //   value: null
        // },

        {
          type: "gender_name",
          title: "性别",
          value: null,
        },
      ],

      detail_info: [
        {
          type: "client_source",
          title: "客户来源",
          value: null,
        },
        {
          title: "公司名称",
          type: "company_name",
          value: null,
        },
        {
          type: "area_id",
          title: "所在城市",
          value: null,
        },
        {
          title: "公司职位",
          type: "company_position",
          value: null,
        },
        {
          title: "详细地址",
          type: "company_place_detail",
          value: null,
        },

        {
          title: "备注",
          type: "com_remarks",
          value: null,
        },
      ],
      dialog: false,
      formLabelWidth: "80px",
      place_props: {
        value: "province_code",
        label: "province_name",
        children: "children",
      },
      indus_props: {
        value: "industry_id",
        label: "name",
        children: "children",
      },
      industry_data: [],
      visible: false,
      search_name: "", //搜索字符串
      valueDate: [], //筛选时间
      tableData: [],
      form: {
        client_name: "",
        company_position: "",
        company_name: "",
        client_sort: "",
        company_place_detail: "",
        client_source: "",
        industry: "",
        company_place: "",
        client_phone: "",
        client_wx: "",
        com_remarks: "",
      }, //表单数据

      rules: {
        client_name: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
          {
            min: 1,
            max: 11,
            message: "长度在 1 到 11 个字符",
            trigger: "blur",
          },
        ],
        company_position: [
          { required: true, message: "请输入公司职位", trigger: "blur" },
        ],
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        client_source: [
          { required: true, message: "请输入客户来源", trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请输入公司职位", trigger: "change" },
        ],
        company_place: [
          { required: true, message: "请选择公司地址", trigger: "change" },
        ],
        client_sort: [
          { required: true, message: "请选择客户类型", trigger: "change" },
        ],
        client_phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        client_wx: [
          { required: true, message: "请输入微信号", trigger: "blur" },
        ],
        recently_staff_name: [
          { required: true, message: "请输入跟进人", trigger: "blur" },
        ],
      },

      multipleSelection: [],
      dialogFormVisible: false, //创建弹框
      //创建数据
      form1: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      }, //右上角筛选数据
      formLabelWidth: "120px",
      search_data: {},
      staff_id: "",
      client_id: "",

      record: [],

      region_value: [""],
      region_options: [
        {
          label: "不限",
          value: "",
        },
      ],
    };
  },
  methods: {
    lufish_user_list(e) {
      require("POST", "/lufish_user/v1/lufish_staff_list/", {}).then((res) => {
        console.log(res);
        if (!res.code) {
          if (res.data.length > 0) {
            this.assign_staff = true;
            this.tableData1 = res.data;
            this.activeName = res.data[0].staff_id;
            this.Pie_chart_value = res.data[0].staff_id; // 职员列表
            this.search();
          }
        } else {
          this.$message.error("职员列表获取失败");
        }
        // this.loading = false
        // this.require_ech()
      });
    },

    //根据时间筛选 选择客户
    changedate(e) {
      console.log();
      if (e == null) {
        this.valueDate = [];
      }
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.search();
    },

    //显示 筛选客户列表 如果有两个参数那就是根据时间筛选
    button_search() {
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.search();
    },
    search(e, id) {
      this.loading = true;
      let obj = this.search_data;
      obj["page"] = this.currentPage;
      let search_data = {};
      obj["search_data"] = search_data;

      if (this.valueDate.length > 0) {
        search_data["start_create_time"] = this.valueDate[0] / 1000;
        search_data["end_create_time"] = this.valueDate[1] / 1000;
      }
      // try {
      //   let search_key = this.options[this.search_value].type;
      //   let search_value = this.search_name;
      //   search_data[search_key] = search_value;
      // } catch (e) {}

      this.tab_name_list.forEach((element, index) => {
        if (element.value != "") {
          search_data[this.options[index].type] = element.value;
          console.log(
            "当前有内容的：",
            element.value,
            this.options[index].type
          );
        }
      });
      if (this.$cookies.get("agent_company_name") != null) {
        if (this.region_value[0] == this.region_value[1]) {
          this.region_value = [""];
        }
      }
      if (this.region_value[this.region_value.length - 1] != "") {
        if (
          this.region_value[this.region_value.length - 1] ==
          this.region_value[this.region_value.length - 2]
        ) {
          search_data["company_place"] =
            this.region_value[this.region_value.length - 1];
          search_data["city"] = "不限";
        } else {
          search_data["company_place"] =
            this.region_value[this.region_value.length - 1];
          search_data["city"] = "";
        }
      }
      if (this.prop_name != "") {
        if (this.prop_name == "next_follow_status") {
          search_data.next_follow_status = this.paging_up_and_down;
        } else if (this.prop_name == "client_sort") {
          search_data.client_sort_status = this.paging_up_and_down;
        } else if (this.prop_name == "follow_count") {
          search_data.follow_info = this.paging_up_and_down;
        }
      }
      if (this.department_value != "") {
        search_data.product_name = this.department_value;
      }
      console.log("当前筛选内容", obj);
      require("post", "/lufish_sale/v1/lufish_high_seas_list/", obj).then(
        (res) => {
          this.loading = false;
          if (!res.code) {
            this.sale_count = res.sale_client_count;
            res.data.map((item) => {
              if (item.company_place_data.city_name) {
                if (
                  item.company_place_data.city_name ==
                  item.company_place_data.province_name
                ) {
                  item.area =
                    item.company_place_data.city_name +
                    "-" +
                    item.company_place_data.district_name;
                } else {
                  item.area =
                    item.company_place_data.province_name +
                    "-" +
                    item.company_place_data.city_name +
                    "-" +
                    item.company_place_data.district_name;
                }
                item.area_id =
                  item.company_place_data.province_name +
                  "/" +
                  item.company_place_data.city_name +
                  "/" +
                  item.company_place_data.district_name;
              } else {
                item.area = "";
                item.area_id = "";
              }
            });
            this.tableData = res.data;
            console.log("列表", res.data);
          } else if (res.code == 112) {
            this.tableData = [];
            this.$message.error(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    input_search(e) {
      if (this.search_value !== "") {
        this.tab_name_list[this.search_value].value = e;
      }
    },
    option_input(e) {
      if (e == "") {
        this.search_name = "";
        this.tab_name_list.forEach((item) => {
          item.value = "";
        });
        // console.log('内容')
      } else {
        this.search_name = this.tab_name_list[this.search_value].value;
      }
    },
    close_tab(e) {
      // 关闭Tab 标签
      this.tab_name_list[e].value = "";
    },
    //将选择的客户放入列表 向基础客户转移
    toggle(row, selected) {
      let select_list = [];
      this.$refs.multipleTable.selection.map((item) => {
        select_list.push(item.client_id);
      });
      if (select_list.length) {
        let obj = { staff_id: this.activeName, client_id_list: select_list };
        this.loading = true;
        require("post", "/lufish_sale/v1/lufish_highseas_work/", obj).then(
          (res) => {
            if (!res.code) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.search();
            } else {
              this.loading = false;
              this.$message.error(res.msg);
            }
          }
        );
      } else {
        this.$message.error("请选择客户");
      }
    },
    deleted_button() {
      // 删除客户
      let select_list = [];
      this.$refs.multipleTable.selection.map((item) => {
        select_list.push(item.client_id);
      });
      if (select_list.length) {
        this.$confirm("是否删除当前选中的客户", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loading = true;
            let obj = { label_code: "delete", client_id_list: select_list };
            require("post", "/lufish_sale/v1/lufish_sale_client/", obj).then(
              (res) => {
                if (!res.code) {
                  this.$message({ message: res.msg, type: "success" });
                  this.search();
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              }
            );
          })
          .catch(() => {});
      } else {
        this.$message.error("请选择需要删除客户");
      }
    },

    pageSizeChange(e) {
      console.log(e);
    },

    current_change(e) {
      this.currentPage = e - 1;
      // this.cilent_Page = e;
      this.client_id_list = [];
      this.search();
    },

    showstatus() {
      require("post", "/lufish_sale/v1/lufish_follow_tags_list/", {}).then(
        (res) => {
          if (!res.code) {
            this.status = res.data;
            // 销售流程ID
            res.data.map((item, index) => {
              this.status_id_dict[item.follow_status_id] = index;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    //点击详情赋值
    showTable(e) {
      this.dialog = true;

      this.client_id = e.client_id;
      this.staff_id = e.staff_id;

      this.client_name = e.client_name;

      this.status_id = this.status_id_dict[e.follow_status_id] || 0;

      this.survey[1].value = e.client_sort;
      //循环数据将数据进行 验证带入值
      for (let i in e) {
        this.record = e.follow_data;
        this.detail_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              item.value = e[i];
            } else {
              item.value = "";
            }
          }
        });

        this.basic_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              item.value = e[i];
            } else {
              item.value = "";
            }
          }
        });
        this.survey.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              item.value = e[i];
            } else {
              item.value = "";
            }
          }
        });
      }
      if(this.survey[2].value == "1970-01-01"){
        this.survey[2].value = ""
      }
      console.log(
        this.detail_info,
        this.basic_info,
        this.survey,
        this.survey,
        this.record
      );
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeTableSort(e) {
      this.client_id_list = [];
      this.currentPage = 0;
      this.cilent_Page = 1;
      if (e.prop == "next_follow_time") {
        this.prop_name = "next_follow_status";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      } else if (e.prop == "client_sort") {
        this.prop_name = "client_sort";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      } else if (e.prop == "follow_count") {
        this.prop_name = "follow_count";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      }
    },

    handleClick(tab, event) {
      if (tab.name != this.Pie_chart_value) {
        this.Pie_chart_value = tab.name;
        this.search();
      }
    },

    department_change() {
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.search();
    },

    handleChange(value) {
      console.log(value);
    },
  },
  created() {
    if (this.$cookies.get("auth_grade") != 20) {
      this.delete_button_torf = true;
    }
    if (this.$cookies.get("auth_grade") == 100) {
      this.jurisdiction = true;
    }
    if (
      this.$cookies.get("auth_grade") == 30 ||
      this.$cookies.get("auth_grade") == 100 ||
      this.$cookies.get("auth_grade") == 80
    ) {
      this.lufish_user_list();
    } else if (this.$cookies.get("auth_grade") == 20) {
      this.search();
    }

    this.showstatus();
    let options = [
      "按客户名称",
      "按公司名称",
      "按客户来源",
      "按手机号",
      "按职位",
      "按客户类别",
      "按备注",
      "按微信号",
      "按地区详情",
      "按跟进人",
    ];
    let search_data = [
      "client_name",
      "company_name",
      "client_source",
      "client_phone",
      "company_position",
      "client_sort",
      "com_remarks",
      "client_wx",
      "company_place_detail",
      "recently_staff_name",
    ];
    let options_add = [];
    options.map((item, index) => {
      options_add.push({
        value: String(index),
        label: item,
        type: search_data[index],
      });
    });
    this.options = options_add;
    console.log(options_add);
    // require("post", "/lufish_sale/v1/client_to_highseas/", {}).then(res => {
    //   console.log(res);
    // });
    require("post", "/lufish_index_data/v1/product_list/", {}).then((res) => {
      console.log(res);
      this.department_list = res.data;
    });
    require("post", "/lufish_index_data/v1/product_list/", {}).then((res) => {
      console.log(res);
      this.department_list = res.data;
    });
  },

  mounted() {
    if (this.$cookies.get("agent_company_name") != null) {
      require("post", "/lufish_sale/v1/agent_city_json/", {}).then((res) => {
        console.log(res);
        this.region_options = res.data;
        this.place_data = res.data;
      });
    } else {
      require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
        this.place_data = res.data;
        this.region_options = this.region_options.concat(res.data);
      });
    }
    axios.get("/static/json/industry.json").then((res) => {
      this.industry_data = res;
    });
  },
};
</script>

<style scoped>
.manager_box {
  margin-top: 68px;
  margin-left: 181px;
  background: #ffff;
  width: calc(100% - 181px);
  border-radius: 4px;
  /* box-shadow: 0 0 6px rgba(0, 0, 0, 0.08); */
  background: #f8f9fa;
}
.main {
  padding-bottom: 70px;
  margin: 16px 0;
  background: #ffff;
  width: 80vw;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(32, 32, 32, 0.08);
  min-height: 80vh;
  position: relative;
}

.btn_box {
  margin-left: 8px;
}

.filter_box {
  display: flex;
  border-bottom: 1px solid #e4e9ed;
  background: #fff;
  padding: 12px 24px;
  box-sizing: border-box;
  align-items: center;
  flex-wrap: wrap;
}
.other_div {
  /* border:1px red solid; */
  margin: 10px 0;
  display: flex;
  /* justify-content: space-between; */
  /* align-content: center; */
  align-items: center;
}

.block {
  /* flex-grow: 1; */
  margin-left: 20px;
}

.detail_info,
.detail_info > div,
.nav_left,
.nav_right,
.rl_flex {
  height: 100%;
}

.nav_title {
  padding: 16px 24px;
  border-bottom: 1px solid #e4e9ed;
  display: flex;
}

.nav_title > div {
  margin-left: 12px;
}

.rl_flex {
  display: flex;
}

.nav_left {
  width: 684px;
  border-right: 1px solid #e4e9ed;
}
.nav_left > div {
  padding: 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e9ed;
}

.over_title {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: #333;
}

.half_fl {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.pagination {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.pagination div {
  color: #aaa;
  font-size: 15px;
}

.status_box {
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  border-radius: 16px;
  position: relative;
}

.status_iter {
  display: flex;
  justify-content: space-between;
}

.status_item {
  display: flex;
  justify-content: center;
}

.status_color {
  color: #3d76f7;
}

.cir.status_back,
.line_item.status_back {
  background: #3d76f7;
}
.cir_item {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
}
.cir_item img {
  height: 24px;
  width: 24px;
}

.line_iter {
  margin-top: 10px;
  background: #f5f6fa;
  line-height: 32px;
  height: 32px;
  overflow: hidden;
  width: 100%;
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
}

.line_item {
  position: absolute;
  height: 10px;
  width: 140px;
  background: #e5e7ee;
  left: 23px;
  top: 10px;
}

.cir {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: #e5e7ee;
  color: #3d76f7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.half_fl .title {
  width: 92px;
}

.half_fl .cont {
  color: #333;
  width: 200px;
  height: 32px;
  line-height: 32px;
}

.half_fl > div {
  align-items: center;
  display: flex;
  width: 50%;
  margin-bottom: 16px;
  font-size: 14px;
  color: #999;
}

.nav_left > div:last-child {
  border-bottom: none;
}

.nav_right {
  /* width: calc(100% - 684px); */
  width: 440px;
  padding: 16px;
  box-sizing: border-box;
  font-size: 14px;
}

.rec_box {
  /* border:1px red solid; */
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}

.rec_box::-webkit-scrollbar {
  width: 4px;
}
.rec_box::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
}

.rec_box .item {
  margin-top: 24px;
  font-size: 14px;
  line-height: 22px;
}

.rec_box .item_flex {
  display: flex;
  justify-content: space-between;
}

.com_name {
  color: #999;
  width: 35%;
}

.item_grow {
  flex-grow: 1;
}

.record {
  margin-bottom: 10px;
}
.btns .el-button {
  float: right;
  margin-top: 5px;
}

.tab_name {
  display: flex;
  flex-wrap: wrap;
  min-height: 50px;
  background: white;
}

.zanwu {
  color: #ccc;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}

.search_button {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/open_sea.vue